import { render, staticRenderFns } from "./CustomSituations.vue?vue&type=template&id=1409dde2&"
import script from "./CustomSituations.vue?vue&type=script&lang=js&"
export * from "./CustomSituations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports